/* tslint:disable */
/* eslint-disable */
import { exists } from '../runtime';
import { SelfLearningContentTypeFromJSON, SelfLearningContentTypeToJSON, } from './SelfLearningContentType';
import { SelfLearningUnitOneOfContentQueryFromJSON, SelfLearningUnitOneOfContentQueryToJSON, } from './SelfLearningUnitOneOfContentQuery';
/**
 * Check if a given object implements the CreateSelfLearningUnitRequest interface.
 */
export function instanceOfCreateSelfLearningUnitRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "contentQuery" in value;
    isInstance = isInstance && "tagList" in value;
    isInstance = isInstance && "iconResourceId" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "contentType" in value;
    return isInstance;
}
export function CreateSelfLearningUnitRequestFromJSON(json) {
    return CreateSelfLearningUnitRequestFromJSONTyped(json, false);
}
export function CreateSelfLearningUnitRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'contentQuery': SelfLearningUnitOneOfContentQueryFromJSON(json['contentQuery']),
        'tagList': json['tagList'],
        'subTitle': !exists(json, 'subTitle') ? undefined : json['subTitle'],
        'iconResourceId': json['iconResourceId'],
        'title': json['title'],
        'contentType': SelfLearningContentTypeFromJSON(json['contentType']),
    };
}
export function CreateSelfLearningUnitRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'contentQuery': SelfLearningUnitOneOfContentQueryToJSON(value.contentQuery),
        'tagList': value.tagList,
        'subTitle': value.subTitle,
        'iconResourceId': value.iconResourceId,
        'title': value.title,
        'contentType': SelfLearningContentTypeToJSON(value.contentType),
    };
}
